import {combineLatest, map} from 'rxjs';
import {RiskMode} from '@/enum';
import {minus, toString} from '@/helper/num';
import {riskUnitsCache$ as innerRiskUnitsCache$} from './ras';
import {type ContractAccountRaw2, contractAccountsCache$} from '../contract-accounts/contract-accounts-cache';
import type {ws} from '@/types';

/**
 * RiskUnitsCache没有全仓数据，从aop推送的accountCache数据中初始化，可能情况：
 *  1、当ras没有推送全仓数据
 *  2、ras推送数据中riskMode为Classic模式
 */
export const riskUnitsCache$ = combineLatest([innerRiskUnitsCache$, contractAccountsCache$]).pipe(
  map(([riskUnitsCache, accountsCache]): Map<string, ws.RiskUnit> => {
    const cache = new Map<string, ws.RiskUnit>();
    for (const [key, c] of riskUnitsCache) {
      cache.set(key, {
        riskMode: c.riskMode,
        valuationCurrency: c.valuationCurrency,
        accountBalanceRv: c.accountBalanceRv,
        totalPosCostRv: c.totalPosCostRv,
        posSide: c.posSide,
        symbol: c.symbol,
        totalOrdUsedBalanceRv: c.totalOrdUsedBalanceRv,
        fixedUsedRv: c.fixedUsedRv,
      });
    }
    return accountsCache
      .toArray()
      .reduce((p: Map<string, ws.RiskUnit>, account: ContractAccountRaw2): Map<string, ws.RiskUnit> => {
        const key = account.currency + 'Invalid';
        if (!p.has(key)) {
          const accountBalanceRv = minus(account.accountBalanceEv, account.isolatedTotalBalanceEv || 0);
          p.set(key, {
            riskMode: RiskMode.Classic,
            valuationCurrency: account.currency,
            accountBalanceRv: accountBalanceRv,
            totalPosCostRv: toString(account.totalCrossPosCostEv || 0),
            posSide: 'Invalid',
            symbol: '',
            totalOrdUsedBalanceRv: toString(account.totalOrdUsedBalanceEv || 0),
            fixedUsedRv: toString(account.crossFixedUsedBalanceEv || 0),
          });
        }
        return p;
      }, cache) as Map<string, ws.RiskUnit>;
  })
);
